const getFieldDataState = error => error ? "error" : "ok";
export default getFieldDataState;